module.exports = __webpack_public_path__ + "img/database.c0d961ac.svg";